module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'zone_attribute_name\'>Name</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'zone_attribute_name\' name=\'zone_attribute[name]\' type=\'text\' value=\'' +
((__t = ( name )) == null ? '' : __t) +
'\'>\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}